import React from "react";
import { Text } from "basis";

export const Fallback = () => (
  <Text textStyle="body2">
    Your statement will show the minimum payment required each month. Clear your
    balance within the plan period to avoid paying interest.
  </Text>
);
